/**
 * Copied from dcide-backend/src/payload-types.ts
 * This file needs to be manually kept in sync with the backend.
 * TODO: Create a single source of truth for permissions and their types
 */

import { z } from 'zod';

export const UserPermissionsSchema = z.object({
    projects: z.array(
        z.object({
            project: z.string(),
            permissions: z.array(
                z.enum(['project.all', 'project.admin', 'project.view', 'project.edit', 'project.delete']),
            ),
        }),
    ),
    components: z.array(
        z.object({
            component: z.string(),
            permissions: z.array(z.enum(['component.all', 'component.view', 'component.edit'])),
        }),
    ),
    global: z.array(
        z.enum([
            'project.all',
            'project.admin',
            'project.view',
            'project.edit',
            'project.delete',
            'component.all',
            'component.view',
            'component.edit',
        ]),
    ),
    team: z.array(z.enum(['team.owner', 'team.admin'])),
});

export type UserPermissions = z.infer<typeof UserPermissionsSchema>;
